import React from "react";
import RenderIf from "../renderIf";
import styled from "styled-components";

import { validate } from "../../constants/validationExp";

import phoneIcon from "../../assets/svgIcons/telephone-icon.svg";
import flagIcon from "../../assets/icons/indian_flag.png";
import inactive_check_circle from "../../assets/icons/inactive-check-circle.png";
import active_check_circle from "../../assets/icons/active-check-circle.png";

const TextInputLayout = (props: any) => {
  const { children, isError, label, referenceText, className, required } =
    props;

  return (
    <TextInputWrapper className={`mb-2 ${className}`}>
      <p className={`md-text mb-1`}>
        {label}
        {required && <span className="text-danger">*</span>}
      </p>
      <div className="">
        <div className=" ">
          <div className={`input_box bg-white ${isError && "border-danger"}`}>
            {children}
          </div>
        </div>
      </div>
      <RenderIf isShow={!!isError}>
        <p className={`x-sm-text mt-1 text-danger`}>{isError}</p>
      </RenderIf>
      <RenderIf isShow={!isError && referenceText}>
        <p className={`x-sm-text mt-1`}>{referenceText}</p>
      </RenderIf>
    </TextInputWrapper>
  );
};

export default TextInputLayout;

const TextInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  .country_code_block {
    border-radius: 8px;
    border: 1px solid rgb(200, 200, 200);
    height: 99%;
    align-items: center;
  }
  input {
    box-sizing: border-box;
    border: none;
    outline: none;
    padding: 0px 10px;
    background: none;
  }
  .input_box {
    display: flex;
    align-items: center;
    height: 40px;
    border-radius: 8px;
    border: 1px solid rgb(200, 200, 200);
  }
  .icon_box {
    height: 25px;
    width: 25px;
    border: 0px solid;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
  }
  .image_icon {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border: 0px solid;
  }
  .country_code_box {
    /* width: 100px; */
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 8px;
    height: 100%;
    border: 1px solid rgb(200, 200, 200);
  }
  .input_box select {
    outline: none;
  }
`;
